import MasterRoleSettingPage from './MasterRoleSettingPage';

export default MasterRoleSettingPage;
